// extracted by mini-css-extract-plugin
export default {"selector":"SentimentSelector_selector__2RYJ+"};